module.exports = function(app) {
	app.directive('eprHexHeader', [function() {
		return {

			restrict: 'A',
			replace: true,
			template: require('directives/common/eprHexHeader.html'),

			scope: {
				headingText: '@eprHexHeader',
				showButton: '=?',
				buttonClass: '@?',
				buttonText: '@?',
				buttonAction: '&?'
			}
		};
	}]);
};
